import React, { useContext } from 'react';

/** Type for an extended component. Can fetch the original component using `.Original` */

export var XComponentMapContext = /*#__PURE__*/React.createContext(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
new Map());
XComponentMapContext.displayName = 'XComponentMapContext';
export var XComponentMapProvider = XComponentMapContext.Provider;

/**
 * Use the replacement component for the provided component if it exists, or just return the provided component.
 * @param Component Component to check if there's a replacement for
 * @returns The replacement component if it exists, otherwise the original component
 */
export function useXComponent(Component) {
  var _ctx$get;
  var ctx = useContext(XComponentMapContext);
  return (_ctx$get = ctx.get(Component)) !== null && _ctx$get !== void 0 ? _ctx$get : Component.Original;
}
//# sourceMappingURL=XComponentMap.js.map